import stockEn from './stock/en.json';
import stockZhHant from './stock/zh-Hant.json';
import stockVi from './stock/vi.json';
import stockTh from './stock/th.json';

export default {
  en: stockEn,
  'zh-Hant': stockZhHant,
  vi: stockVi,
  th: stockTh,
};
